import {FC} from 'react'

const PRACTITIONER_ROLES = ['BUSINESS', 'INDIVIDUAL']

type Props = {
  isBlocked?: boolean
  availableRoles?: string[]
  premium?: boolean
  premium_request?: string
}

// Mirrors the appVisibility logic in the backend's fetchPaginatedUsers
// (helpers/user.helper.js): a practitioner (BUSINESS or INDIVIDUAL in
// availableRoles) only actually shows up in the app while premium is
// true or premium_request is "approved" - a lapsed/never-approved
// practitioner is invisible to real users even if not blocked. A
// CLIENT-only profile has no browsable profile to begin with, so that
// condition doesn't apply to it. This used to be conflated: the badge
// here only ever reflected isBlocked, so an expired-premium
// practitioner still read as "Active" while nobody could see them in
// the app.
const UserStatusCell: FC<Props> = ({isBlocked, availableRoles, premium, premium_request}) => {
  const isPractitioner = Array.isArray(availableRoles)
    ? availableRoles.some((role) => PRACTITIONER_ROLES.includes(role))
    : false

  const isVisibleInApp =
    !isBlocked && (!isPractitioner || premium === true || premium_request === 'approved')

  return (
    <>
      {' '}
      {isVisibleInApp ? (
        <div className='badge badge-light-success fw-bolder'>Active</div>
      ) : (
        <div className='badge badge-light-danger fw-bolder'>Inactive</div>
      )}
    </>
  )
}

export {UserStatusCell}
